import Suspense from "components/shared/Suspense";
import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import faCirclePlus from "icons/duotone/circle-plus.svg";
import { lazy, useState } from "react";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { PageSerializersPromptsLayout } from "types/serializers";

const AddBookForm = lazy(() => import("./AddBookForm"));

export default function AddBookButton({
  prompt,
}: {
  prompt: PageSerializersPromptsLayout;
}) {
  const isLoggedIn = useIsLoggedIn();
  const [isOpen, setIsOpen] = useState(false);

  if (!isLoggedIn) {
    return <></>;
  }

  return (
    <>
      <div className="grow flex justify-end items-center mr-2">
        <Button
          variant="primary"
          className="space-x-1"
          size="sm"
          onClick={() => setIsOpen(true)}
        >
          <Icon icon={faCirclePlus} />
          <span>
            Add<span className="hidden lg:inline"> a Book</span>
          </span>
        </Button>
      </div>

      {isOpen && (
        <Suspense>
          <AddBookForm prompt={prompt} onClose={() => setIsOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
